<app-session-handoff-page
  [pageTitle]="pageTitle()"
  [cardTitle]="cardTitle()"
  [cardMessage]="cardMessage()"
  (participantJoined)="onParticipantJoined($event)"
>
</app-session-handoff-page>
